import graphql from 'babel-plugin-relay/macro';
import { commitMutation } from 'react-relay';
import { ConnectionHandler } from 'relay-runtime';
import { SpanType, withSpanAsync } from 'tracing';

const mutation = graphql`
  mutation setUserDeveloperMutation($input: SetUserDeveloperInput!) {
    setUserDeveloper(input: $input) {
      userRowId
      isDeveloper
    }
  }
`;

// The developer role is global, not scoped to the account: the accountId and
// connectionKey are only there to locate the member row to refresh in the store.
export const setUserDeveloper = (
  environment,
  userRowId,
  isDeveloper,
  accountId,
  connectionKey
) =>
  withSpanAsync('setUserDeveloper', SpanType.mutation, async () => {
    const variables = {
      input: {
        userRowId,
        isDeveloper
      }
    };

    commitMutation(environment, {
      mutation,
      variables,
      onError: err => {
        console.error(err);
      },
      updater: store => {
        const payload = store.getRootField('setUserDeveloper');
        if (!payload) return;

        const account = store.get(accountId);
        const members = ConnectionHandler.getConnection(account, connectionKey);
        const edges = members && members.getLinkedRecords('edges');
        if (!edges) return;

        const user = edges
          .map(edge => {
            const node = edge.getLinkedRecord('node');
            return node && node.getLinkedRecord('user');
          })
          .find(record => record && record.getValue('rowId') === userRowId);

        if (user) user.setValue(payload.getValue('isDeveloper'), 'isDeveloper');
      }
    });
  });
